var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{staticClass:"hidden-sm-and-down",attrs:{"lg":4,"md":2}}),_c('el-col',[_c('router-view')],1),_c('el-col',{staticClass:"hidden-sm-and-down",attrs:{"lg":4,"md":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }